import api from '@/soluqr/api/client';
import { getCurrentHostname } from './getCurrentHostname';
import { isCustomDomain } from './isCustomDomain';

/** Dominio propio o subdominio de tenant en soluqr.cl (p. ej. bigmatigrill.soluqr.cl). */
export function shouldAttemptHostnameTenantResolve(hostname) {
  const h = String(hostname || '').trim().toLowerCase();
  if (!h) return false;
  if (isCustomDomain(h)) return true;
  if (h === 'soluqr.cl' || h === 'www.soluqr.cl') return false;
  if (h.endsWith('.soluqr.cl')) return true;
  return false;
}

/**
 * Intenta resolver el negocio por hostname (custom domain / subdominio),
 * sin afectar rutas actuales /menu/:businessId.
 *
 * @returns {Promise<object|null>} business mínimo o null si no se resolvió
 */
export async function resolveTenantBusiness() {
  try {
    const hostname = getCurrentHostname();
    if (!hostname) return null;
    if (!shouldAttemptHostnameTenantResolve(hostname)) return null;

    const { data } = await api.get('/business/resolve-hostname', {
      params: { hostname },
      // No debe depender de auth; si hay token, api lo agrega igual.
    });

    if (data?.resolved === true && data?.business) return data.business;
    return null;
  } catch {
    return null;
  }
}
